import React, { useEffect } from 'react';
import { Breadcrumb, Tag, Spin } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { NetworkFormatter } from 'components/tables/NinjaTable/formatters';
import ninjaApi from 'store/redux/apis';

const InnerReportingBreadCrumbs = ({ id, dates }) => {
  const [getAdsetGeneralInfoQuery, { data, isLoading, isFetching }] =
    ninjaApi.useLazyAdsetGeneralInfoQuery();

  useEffect(() => {
    if (dates && id) {
      const filters = { ...dates, adset_id: id };
      getAdsetGeneralInfoQuery({ filters });
    }
  }, [id, dates]);

  if (isLoading || isFetching) {
    <Spin size='small' />;
  }

  if (!data) return null;

  const general = data?.data;

  const account = { label: 'Account', value: general?.network_account_name };
  const campaign = { label: 'Campaign', value: general.campaign_name };
  const adset = { label: 'Adset', value: general.name };
  const ad = general?.ads?.[0]?.name ? { label: 'Ad', value: general.ads[0].name } : null;

  const items = [account, campaign, adset, ad].filter(Boolean);

  const renderItem = (item) => (
    <div className='flex flex-col  leading-tight'>
      <span className='!text-xs font-medium truncate'>{item.value}</span>
      <Tag
        bordered={false}
        className='!text-[10px] bg-info-background w-fit truncate mt-1 rounded-lg h-4 flex items-center font-medium'
      >
        {item.label}
      </Tag>
    </div>
  );

  return (
    <div className='px-1 py-1  rounded-lg'>
      <Breadcrumb
        className='text-xs font-normal flex items-center'
        separator={<RightOutlined style={{ fontSize: '10px', color: '#b8b8b8' }} />}
      >
        <Breadcrumb.Item>
          <div className='flex flex-col leading-tight items-left'>
            <NetworkFormatter row={general} />
            <Tag
              bordered={false}
              className='!text-[10px] bg-info-background w-fit truncate mt-1 rounded-lg h-4 flex items-center font-medium'
            >
              Network
            </Tag>
          </div>
        </Breadcrumb.Item>

        {items.map((item, idx) => (
          <Breadcrumb.Item key={idx}>{renderItem(item)}</Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default InnerReportingBreadCrumbs;
